<template>
  <div class="animated fadeIn">
    <h2>Imprint</h2>

    <h4 style="margin-top:1em">MSM Germany - Marketing, Service &amp; Management GmbH</h4>

    <p style="margin-top:1em">An der Alten Ziegelei 32<br/>
    48157 Münster<br/>
    Fon: +49(0)251 - 1 42 35 - 0<br/>
    Fax: +49(0)251 - 1 42 35 - 29<br/>
    <a href="mailto:info@msm-group.com" title="info@msm-group.com">info@msm-group.com</a></p>

    <p><strong>Managing Director:</strong> Ferdinand Hissmann, Christian Karrenbauer, Timo Gimon<br/>
    <strong>Register court:</strong> Amtsgericht Münster · <strong>Register Number:</strong> HRB 37 13</p>

    <p><strong>Sales tax identification number according § 27 a VAT law:</strong> DE 126 114 101</p>

    <p><strong>Disclaimer:</strong><br/>
    Despite careful content control we assume no liability for the content of external links.<br/>
    For the content of linked pages their operators are responsible.</p>

    <h2 style="margin-top:1em">Impressum</h2>

    <h4 style="margin-top:1em">MSM Germany - Marketing, Service &amp; Management GmbH</h4>

    <p style="margin-top:1em">An der Alten Ziegelei 32<br/>
    48157 Münster<br/>
    Fon: +49(0)251 - 1 42 35 - 0<br/>
    Fax: +49(0)251 - 1 42 35 - 29<br/>
    <a href="mailto:info@msm-group.com" title="info@msm-group.com">info@msm-group.com</a></p>

    <p><strong>Vertretungsberechtigte Geschäftsführer:</strong> Ferdinand Hissmann, Christian Karrenbauer, Timo Gimon<br/>
    <strong>Registergericht:</strong> Amtsgericht Münster · <strong>Registernummer:</strong> HRB 37 13 <br/>
    <strong>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</strong> DE 126 114 101</p>
    
    <p><strong>Haftungshinweis:</strong><br/>
    Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
    Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
  </div>
</template>

<script>
export default {
  name: 'Imprint'
}
</script>
